import type { ComposedViewEnum, OnlineFixedPageEnum, PredefinedViewEnum } from '../config'
import type { DisplayConditionType } from './condition'

export enum SectionTypeEnum {
  CoverPage = 'CoverPage',
  Home = 'Home',
  Energy = 'Energy',
  Savings = 'Savings',
  Go = 'Go',
}

export type SectionConfig = {
  sectionId: SectionTypeEnum
  views: SectionViewConfig[]
}

export interface ISectionView {
  type: SectionViewTypeEnum
  displayConditions?: DisplayConditionType[]
  name: string
}

export enum SectionViewTypeEnum {
  CustomView = 'custom_view', // Single custom page
  PredefinedViews = 'predefined-views', // Set of prefixed pages
  ComposedViews = 'composed-views', // Set of pages with condition
}

export type CustomViewConfig = {
  type: SectionViewTypeEnum.CustomView
  displayConditions: DisplayConditionType[]
  pageId: string
}

export type PredefinedViewConfig = {
  type: SectionViewTypeEnum.PredefinedViews
  displayConditions: DisplayConditionType[]
  name: PredefinedViewEnum
  views: {
    displayConditions: DisplayConditionType[]
    pageId: OnlineFixedPageEnum
  }[]
}

export type ComposedViewConfig = {
  type: SectionViewTypeEnum.ComposedViews
  displayConditions: DisplayConditionType[]
  name: ComposedViewEnum
  views: (CustomViewConfig | PredefinedViewConfig)[]
}

export type SectionViewConfig = PredefinedViewConfig | ComposedViewConfig | CustomViewConfig
